<template>
  <component :is="CompareMenu" v-if="skus?.length" />
</template>

<script lang="ts" setup>
const { skus } = useComparisonState();

const CompareMenu = defineAsyncComponent(() => import(`./CompareMenu.vue`));
</script>
